import { render, staticRenderFns } from "./YiKeTu.vue?vue&type=template&id=f5ac3310&scoped=true"
import script from "./YiKeTu.vue?vue&type=script&lang=js"
export * from "./YiKeTu.vue?vue&type=script&lang=js"
import style0 from "./YiKeTu.vue?vue&type=style&index=0&id=f5ac3310&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ac3310",
  null
  
)

export default component.exports